import apiCall from "../axios/apiCall";

const controller = "notificacion";

export default {
    getNotificaciones: async () => {
        let response = { success: true };
        const method = ``;
        try {
            const apiResponse = await apiCall.get(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = apiCall.handleCatch(error);
        }
        return response;
    },
    getNotificacionesBySystem: async (id_sistema) => {
        if (!id_sistema) return;

        let response = { success: true };
        const method = `sistema/${id_sistema}`;
        try {
            const apiResponse = await apiCall.get(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = apiCall.handleCatch(error);
        }
        return response;
    },
    getNotificacionsByUser: async () => {
        let response = { success: true };
        const method = `by_user`;
        try {
            const apiResponse = await apiCall.get(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = apiCall.handleCatch(error);
        }
        return response;
        
    },
    createNotificacion: async (data) => {
        let response = { success: true };
        const method = ``;
        try {
            const apiResponse = await apiCall.post(controller, method, data);
            response.message = apiResponse?.data;
        } catch (error) {
            response = apiCall.handleCatch(error);
        }
        return response;
    },
    updateNotificacion: async (data) => {
        let response = { success: true };
        const method = ``;
        try {
            const apiResponse = await apiCall.put(controller, method, data);
            response.message = apiResponse?.data;
        } catch (error) {
            response = apiCall.handleCatch(error);
        }
        return response;
    },
    deleteNotificacion: async (id) => {
        let response = { success: true };
        const method = `${id}`;
        try {
            const apiResponse = await apiCall.delete(controller, method);
            response.message = apiResponse?.data;
        } catch (error) {
            response = apiCall.handleCatch(error);
        }
        return response;
    },
}